var map = {
	"./howto1.svg": 1414,
	"./howto2.svg": 6380,
	"./howto3.svg": 5003,
	"./howto4.svg": 3718,
	"./howto5.svg": 9442,
	"./howto6.svg": 8067
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8105;